'use strict';
/* global SitePreferences */

// Initialize the libraries required by the PDP
var dialog = require('../../dialog'),
    dialogTooltip = require('../../dialog-tooltip'),
    productStoreInventory = require('../../storeinventory/product'),
    tooltip = require('../../tooltip'),
    productTile = require('../../product-tile'),
    util = require('../../util'),
    addToCart = require('./addToCart'),
    availability = require('./availability'),
    image = require('./image'),
    productNav = require('./productNav'),
    productSet = require('./productSet'),
    enlargeImageEvents = require('./enlargeImage'),
    recommendations = require('./recommendations'),
    sizeChart = require('../../sizechart'),
    variant = require('./variant'),
    validator = require('../../validator'),
    progress = require('../../progress'),
    tealium = require('../../../../../int_tealium/cartridge/js/tealium/tealium'),
    page = require('../../page'),
    imagesLoaded = require('imagesloaded'),
    SessionAttributes = window.SessionAttributes;


/**
 * @function initializeDOM
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */
function initializeDom() {

    // Only evaluate the productNavigation initialization if the sitePreference is enabled
    if (window.SitePreferences.hasOwnProperty('PRODUCT_NAV_ENABLED')) {

        // Flag to enable / disable the product navigation in the PDP
        if (window.SitePreferences.PRODUCT_NAV_ENABLED === true) {
            productNav();
        }

    }

    recommendations();
    tooltip.init();
    productTile.init();

}

//SM-6400
$(window).on('load', function () {
    if ($('#wrapper').hasClass('quick-order-page')) {
        cqoswatches();

    }
});

/**
* @function CQOSwatches
* @description making only available swatches selected for CQO page.
*/
function cqoswatches() {
    //SM-6400 (For CQO - Pre-select Color AND/OR Size on PDP when only 1 available)
    var varAttributes = ['color', 'size', 'width', 'waist', 'length', 'sizeFamily', 'braBandSize', 'braCupSize', 'shoeSize', 'shoeWidth'];
    $(varAttributes).each(function () {
        var curr = this.toLowerCase();
        $('.product-variation-content').each(function () {
            if ($(this).find('.swatches.' + curr + ' li.selectable').length == 1) {
                $(this).find('.swatches.' + curr + ' li.selectable:first .swatchanchor').trigger('click');
            }
        });
    });
}

/**
 * @function initializeEvents
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {

    // Initialize local variables
    var $pdpMain;
    var $quickView;

    // Create a reference to the PDP
    $pdpMain = $('#pdpMain');
    $quickView = $('#QuickViewDialog');

    // Initialize each of the libraries
    addToCart();
    availability();
    image();

    window.util = util;
    window.imagesLoaded = imagesLoaded;


    if (window.location.href.indexOf("isCqoRedirect") > 1) {
        MERCH_UTILS.setProductFindingMethodCookie("CQO:Search");
    }

    // When initializing the page, inspect the form-factor to render either a
    // mobile or desktop specific set of images in the thumbnail rail
    image.renderResponsiveThumbnailRailImages(true); // SM-1707 : false is changed to true to fix image issue if a user opens quickview second time.
    //initEvents
    $('#pdpMain .swatchanchor img').unveil(0,variant.pdpSwatchLazyLoad);

    // If the browser-window re-sized, re-render the thumbnail images
    $(window).resize(function () {
        image.renderResponsiveThumbnailRailImages(true); // SM-1707 : false is changed to true to fix image issue if a user opens quickview second time.
    });

    // Attach an errpr-handler to the primary image
    $pdpMain.find('.primary-image').on('error', function () {
        // Initialize local variables
        var $img = $(this);

        // Reset the image source for the product-image being displayed
        $img.attr('src', window.product404Images.largeImage);
    });

    // If this is a productSet -- then init the productSet library
    if ($pdpMain.hasClass('standardproductset') || $pdpMain.hasClass('specialproductset')) {
        productSet();
    }

    // Initialize the remaining libraries
    enlargeImageEvents.init();
    sizeChart.init();
    if ($("#wrapper").hasClass("quick-order-page")) {
        initializeQuickOrderForm();
    }

    function lastVisited() {

        var $lastVisitedSearchResultItems = $('.last-visited .search-result-items'),
            ItemData = {
                desktop: { slides: 4, scroll: 1 },
                tablet: { break: 1350, slides: 3, scroll: 1 },
                Phablet: { break: 1024, slides: 3, scroll: 1 },
                mobile: { break: 767, slides: 1.5, scroll: 1 },
                Smobile: { break: 767, slides: 1.5, scroll: 1 }
            },
            totalItems = $lastVisitedSearchResultItems.children().length;
        ItemData.desktop.slides > totalItems ? ItemData.desktop.slides = totalItems : null;
        ItemData.tablet.slides > totalItems ? ItemData.tablet.slides = totalItems : null;
        ItemData.Phablet.slides > totalItems ? ItemData.Phablet.slides = totalItems : null;
        ItemData.mobile.slides > totalItems ? ItemData.mobile.slides = totalItems : null;

        var lastVisitedSlickConfig = {
            slidesToShow: ItemData.desktop.slides,
            slidesToScroll: ItemData.desktop.slides > totalItems ? ItemData.desktop.scroll : ItemData.desktop.slides,
            dots: false,
            infinite: false,
            arrows: true,
            responsive: [
                {
                    breakpoint: ItemData.tablet.break,
                    settings: {
                        slidesToShow: ItemData.tablet.slides,
                        slidesToScroll: ItemData.tablet.slides > totalItems ? ItemData.tablet.scroll : ItemData.tablet.slides,
                        arrows: true
                    }
                },
                {
                    breakpoint: ItemData.Phablet.break,
                    settings: {
                        slidesToShow: ItemData.Phablet.slides,
                        slidesToScroll: ItemData.Phablet.slides > totalItems ? ItemData.Phablet.scroll : ItemData.Phablet.slides,
                        arrows: true
                    }
                },
                {
                    breakpoint: ItemData.mobile.break,
                    settings: {
                        slidesToShow: ItemData.mobile.slides,
                        slidesToScroll: ItemData.mobile.scroll,
                        arrows: false
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        };

        if ($lastVisitedSearchResultItems.length > 0 && !$('.quick-view').is(':visible')) {
            // wraps slick arrows with <li> tags after slick initialization.
            $lastVisitedSearchResultItems.on('init breakpoint', function(){
                if($lastVisitedSearchResultItems.prop('nodeName') == 'UL')
                $($lastVisitedSearchResultItems.children("button.slick-prev, button.slick-next")).wrap("<li></li>");
            });
            $lastVisitedSearchResultItems.slick(lastVisitedSlickConfig);
            util.handleSlickArrowFunc($lastVisitedSearchResultItems,ItemData.mobile.break);
        }
    }

    // Don't execute lastVisited when instantiating the quickView from the PDP
    if ($quickView.length === 0) {
        lastVisited();
    }

    /**
     * @description Last Visited slider events.
     */
    var lastVisitedSlickConfig = {};

    // Determine if store-pickup is enabled
    if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
    }

    // Add to Wishlist and Add to Gift Registry links behaviors
    $pdpMain.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
        var data = util.getQueryStringParams($('.pdpForm').serialize());
        if (data.cartAction) {
            delete data.cartAction;
        }
        var url = util.appendParamsToUrl(this.href, data);
        this.setAttribute('href', url);
    });

    // Prevent clicks on the main pdp-image and catalog quick order
    $pdpMain.on('click', 'img.main-image , img.primary-image-quick-order', function (e) {
        e.preventDefault();
    });

    // Add toggle functionality for Shipping info in PDP
    $pdpMain.on('click', '.clickhere', function (e) {
        e.preventDefault();
        $(this).closest(".productinfo ").find('.shippinginfo').toggleClass('hide');
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? "false" : "true");
        if (!$(this).hasClass('opened')) {
            $(this).text(Resources.CLOSE).addClass('opened');
        } else {
            var text = Resources.READ_MORE;
            if ($(this).hasClass("clickhere-cqo")) {
                text = Resources.READ_MORE;
            }
            $(this).text(text).removeClass('opened');
        }
    });

    // SC-44 and SC-27 Chages for wishlist link
    $pdpMain.on('click', '.wishlist', function (e) {
        if (SessionAttributes.IS_CUSTOMER_AUTHENTICATED) {
            e.preventDefault();
            var pid,
                self = this,
                url,
                action;
            if (typeof $(this).parents().find("#pid").val() !== 'undefined') {
                pid = $(this).parents().find("#pid").val();
            } else {
                pid = this.parentElement.parentElement.pid.value;
            }
            if ($(self).attr("data-uuid") === '') {
                url = util.appendParamsToUrl(Urls.addToWishlist, {
                    'format': 'ajax',
                    'pid': pid
                });
                action = 'add';
            } else {
                url = util.appendParamsToUrl(Urls.removeFromWishlist, {
                    'format': 'ajax',
                    'uuid': $(self).attr("data-uuid")
                });
                action = 'remove';
            }
            $.ajax({
                url: url
            }).done(function (data) {
                if (action === 'add') {
                    if (data.success && data.uuid !== '') {
                        $(self).attr("data-uuid", data.uuid);
                    }
                    $('.wishlist-logo').addClass("added-to-wishlist");
                    $('.wishlist a').attr('title', Resources.ADDED_TO_WISHLIST_TITLE);
                    $('.wishlist .wishlist-text').html(Resources.ADDED_TO_WISHLIST);
                } else {
                    $(self).attr("data-uuid", '');
                    $('.wishlist-logo').removeClass("added-to-wishlist");
                    $('.wishlist a').attr('title', Resources.ADD_TO_WISHLIST_TITLE);
                    $('.wishlist .wishlist-text').html(Resources.ADD_TO_WISHLIST);
                }
            });
        }
        //SC-27 Add cookie when product is added to the wishlist
        if (typeof (MERCH_UTILS) !== 'undefined') {
            var mpid = '';
            if (typeof $(this).parents().find("#mpid").val() !== 'undefined') {
                mpid = $(this).parents().find("#mpid").val();
            } else {
                mpid = this.parentElement.parentElement.mpid.value;
            }
            // if (mpid !== '') {
            //     MERCH_UTILS.setProductAddToCartCookie("_productAddToCartMethod", mpid, MERCH_UTILS.getCookie('_productFindingMethodOSS'));
            // }
        }
    });

    // Add toggle functionality for CA Prop 65 info in PDP
    $pdpMain.on('click', '.prop65-clickhere', function (e) {
        e.preventDefault();
        $('.prop65-info').toggle();
        if (!$(this).hasClass('opened')) {
            $(this).text(Resources.SEE_LESS).addClass('opened');
        } else {
            $(this).text(Resources.SEE_DETAILS).removeClass('opened');
        }
    });

    // Setup the product-option select-event
    $pdpMain.on('change', '.product-options select', function () {
        var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
        var selectedItem = $(this).children().filter(':selected').first();
        salesPrice.text(selectedItem.data('combined'));
    });

    // Prevent default behavior of thumbnail link and add this Button
    $pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
        e.preventDefault();
    });

    // Initialize the quantity-change events
    $pdpMain.on('change', '.quantityinput', function (e) {
        e.preventDefault();
        var $curObj = $(this),
            curValue = parseInt($curObj.val()),
            $parent = $curObj.closest('.product-add-to-cart'),
            $atsMsg = $parent.find('.quantity-ats-message'),
            $curObjCustomSelect = $(this).closest('.custom-select');
        if ($parent.find('input.availablity-count-val').length > 0) {
            var avQty = parseInt($parent.find('input.availablity-count-val').val());
            if (curValue > avQty) {
                if ($(window).width() > 1024) {
                    // handling for custom select box in desktop
                    $curObjCustomSelect.find('.selection-list li').removeClass('selected');
                    $curObjCustomSelect.find('.selection-list li').eq(avQty - 1).addClass('selected').nextAll('li').addClass('hide');
                    $atsMsg.addClass('padding-eight').removeClass('hide');
                } else {
                    $curObj.find('option').removeAttr('selected');
                    $curObj.find('option').filter("[value='" + avQty + "']").attr('selected', 'selected').change().nextAll('option').addClass('hide');
                    $atsMsg.addClass('padding-eight').removeClass('hide');
                }
            } else {
                $atsMsg.addClass('hide').removeClass('padding-eight');
            }
        }
    });

    // Initialize the hemming-checkbox behavior
    $('body').on('click', '.product-hemming-checkbox', function () {
        var $this = $(this),
            $hemmingParent;

        //check if cqo page || (pdp & quickview)
        if ($this.closest('.variation-add-to-cart-content', $this).length > 0) {
            $hemmingParent = $this.closest('.variation-add-to-cart-content', $this);
        } else {
            $hemmingParent = $this.closest('.hemmingmonograming', $this);
        }

        if ($this.is(':checked')) {
            $hemmingParent.find('input[name$="_hemming"]').val(1);
            $this.closest('.product-hemmable').find('.hemming-drawer').show();
            $this.closest('.product-hemmable').find('.hemming-drawer').attr('aria-expanded','true');
            var hemmingOptionValue = '',
                selectedHemmingOption = $hemmingParent.find('.hemming-drawer .hemming-option.selected');
            if ($(selectedHemmingOption).length > 0) {
                hemmingOptionValue = $(selectedHemmingOption).attr('data-hemming-option');
            }
            $hemmingParent.find('.hemmingoption').val(hemmingOptionValue);
        } else {
            $hemmingParent.find('input[name$="_hemming"]').val(0);
            // var $hemmingmonograming = $this.closest('.hemmingmonograming');            
            $hemmingParent.find('.hemming-error-msg').hide();
            $hemmingParent.find('.hemming-error-msg').closest('.product-hemmable').removeClass('error-msg');
            $hemmingParent.find('.hemmingoption').val('');
            $this.closest('.product-hemmable').find('.hemming-drawer').hide();
            $this.closest('.product-hemmable').find('.hemming-drawer').attr('aria-expanded','false');
        }
    });

    // Initialize the hemming-drawer behavior
    $('body').on('click', '.hemming-drawer ul li.hemming-option', function () {
        var $this = $(this),
            $parent = $this.parent(),
            $viewDetailsLength = $('#QuickViewDialog a.view-details-link').length,
            $viewDetailsUrl, viewDetailsHref, updatedhref, viewDetailsUrl,
            $hemmingParent;

        //check if cqo page || (pdp & quickview)
        if ($this.closest('.variation-add-to-cart-content', $this).length > 0) {
            $hemmingParent = $this.closest('.variation-add-to-cart-content', $this);
        } else {
            $hemmingParent = $this.closest('.hemmingmonograming', $this);
        }

        //apply hemming option
        $parent.find('.hemming-option.selected').find('button').attr('aria-selected','false');
        $parent.find('.hemming-option.selected').find('button').attr('aria-label',$parent.find('.hemming-option.selected').find('button').html());
        $parent.find('.hemming-option.selected').removeClass('selected');
        $this.addClass('selected');
        $(this).find('button').attr('aria-selected','true');
        $(this).find('button').attr('aria-label','Selected '+$(this).find('button').html());
        $hemmingParent.find('.hemmingoption').val($this.attr('data-hemming-option'));
        $hemmingParent.find('.hemming-error-msg').closest('.product-hemmable', $this).removeClass('error-msg');
        $hemmingParent.find('.hemming-error-msg').hide();

        if ($viewDetailsLength > 0) {
            $viewDetailsUrl = $('#QuickViewDialog a.view-details-link');
            viewDetailsHref = $viewDetailsUrl[0].href;

            updatedhref = variant.updateUrlWithHemmingOption(viewDetailsHref, $this.closest('.pdpForm'), $this.data('swatchtype'));
            updatedhref = updatedhref.replace('?', '&');
            $viewDetailsUrl.attr('href', updatedhref);
        }
    });

    dialogTooltip.events();

    // Initialize the open / close inventory select
    $pdpMain.on('click', '.inventory select', function () {
        $(this).closest('.inventory').toggleClass('open');
    }).on('blur', '.inventory select', function () {
        $(this).closest('.inventory').removeClass('open');
    });

    $pdpMain.on('click', '.variant-dropdown select', function () {
        $(this).closest('.variant-dropdown').toggleClass('open');
    }).on('blur', '.variant-dropdown select', function () {
        $(this).closest('.variant-dropdown').removeClass('open');
    });

    // Add the personal message to the PDP
    $pdpMain.on('click', '.personal-message input[type="checkbox"]', function () {
        if ($(this).is(':checked')) {
            $(this).parents('.product-add-to-cart').find('.fields-address').addClass('active');
        } else {
            $(this).parents('.product-add-to-cart').find('.fields-address').removeClass('active');
            $(this).closest('.pdpForm').find('.please-select').text('');
            $(this).parents('.product-add-to-cart').find('.fields-address input, .fields-address textarea').val('');
        }
        util.giftMessageCharCount();
        if ($('.ui-dialog.quick-view').is(':visible')) {
            util.loadSrollForQVProduct();
        }
    });

    $('body').on('change', '.monogramming-enabled-class', function (e) {
        e.preventDefault();
        if ($(this).prop('checked')) {
            $(this).closest('.hemmingmonograming').find('input[name$="_monogramming"]').val(1);
            if ($('.single-selection').length > 0) {
                $('input[name="monogrammingFontOpt"]').val($('select[name=monogram-font]').closest('.custom-select-hide').find('option:selected').val());
                $('input[name="monogrammingColorOpt"]').val($('select[name=monogram-color]').closest('.custom-select-hide').find('option:selected').val());
                $('input[name="monogrammingLocationOpt"]').val($('select[name=monogram-location]').closest('.custom-select-hide').find('option:selected').val());
            }
        } else {
            $(this).closest('.hemmingmonograming').find('input[name$="_monogramming"]').val(0);
        }
        if ($('.ui-dialog.quick-view').is(':visible')) {
            util.loadSrollForQVProduct();
        }
    });

    $('body').on('change', 'input[name="product-hemming"]', function (e) {
        e.preventDefault();
        var $this = $(this),
            $hemmingParent;
        //check if cqo page || (pdp & quickview)
        if ($this.closest('.variation-add-to-cart-content', $this).length > 0) {
            $hemmingParent = $this.closest('.variation-add-to-cart-content', $this);
        } else {
            $hemmingParent = $this.closest('.hemmingmonograming', $this);
        }

        if ($(this).prop('checked')) {
            $hemmingParent.find('input[name$="_hemming"]').val(1);
        } else {
            $hemmingParent.find('input[name$="_hemming"]').val(0);
        }

        if ($('.ui-dialog.quick-view').is(':visible')) {
            util.loadSrollForQVProduct();
        }

    });

    //Character count in the text-area
    util.giftMessageCharCount();

    //add to personal message PDP
    util.addPersonalMessage();

    $pdpMain.on('change', '.monogramming-font .font', function (e) {
        e.preventDefault();
        $('input[name="monogrammingFontOpt"]').val($('select[name=monogram-font]:visible option:selected').val());
    });
    $pdpMain.on('change', '.monogramming-color', function (e) {
        e.preventDefault();
        $('input[name="monogrammingColorOpt"]').val($('select[name=monogram-color]:visible option:selected').val());
    });
    $pdpMain.on('change', '.monogramming-location', function (e) {
        e.preventDefault();
        $('input[name="monogrammingLocationOpt"]').val($('select[name=monogram-location]:visible option:selected').val());
    });

    // monogramming validation #217
    $('body').on('click', '.monogramming-enabled-class', function () {
        if ($(this).prop('checked')) {
            $(this).closest('.product-monogramming').find('.monogramming-fields').show();
        } else {
            $(this).closest('.product-monogramming').find('.monogramming-fields').hide();
            $(this).closest('.product-monogramming').find('.mono-error').removeClass('mono-error');
            $(this).closest('.product-monogramming').removeClass('error-msg');
            var $hemmingmonograming = $(this).closest('.hemmingmonograming');
            $hemmingmonograming.find('.monogramming-fields').find('select.monogram-font-class').val('').change();
            $hemmingmonograming.find('.monogramming-fields').find('select.monogram-location-class').val('').change();
            $hemmingmonograming.find('.monogramming-fields').find('select.monogram-color-class').val('').change();
            $hemmingmonograming.find('.monogramming-fields').find('.input-fields-set input[type="text"]').val('');
            $hemmingmonograming.find('#monogrammingText').val('');
            $hemmingmonograming.find('.monogramming-fields').find('.monogramming-preview .input-textarea').val('');
        }
    });

    function checkCharcters(char) {
        var testRegEx_az = /[A-Za-z]/g,
            toString = char,
            regX = new RegExp(testRegEx_az),
            tester = (char.length - 1) > 0 ? regX.test(char.substr((char.length - 1), (char.length - 1))) : regX.test(char);
        if (!tester) {
            toString = char.substr(0, (char.length - 1));
        }
        return {
            status: tester,
            value: toString
        }
    }



    $('body').on('keydown', '.monogramming-textfield', function (key) {
        if (checkCharcters(key.key).status) {
            return checkCharcters(key.key).value;
        } else {
            return checkCharcters(key.key).status;
        }
    });

    $('body').on('keyup', '.monogramming-textfield', function () {

        if (!checkCharcters(this.value).status) {
            this.value = checkCharcters(this.value).value;
        }

        $(this).removeClass('mono-error');
        $(this).closest('.product-monogramming').removeClass('error-msg');
        var text = '';

        // end of monogramming validation #217
        //  Moved from the character-left div to the monogramming-textfield so that
        //  the edits don't disappear when the variant changes
        var maximum = $(this).closest('.character-left').find('.monogramming-textfield').data('monogramming');
        var length = $(this).val().length;
        var character = $(this).data('type');

        $(this).closest('.character-left').find('.monogramming-textfield').val($(this).closest('.character-left').find('.monogramming-textfield').val().substr(0, maximum));
        if (maximum >= length) {
            var char = maximum - length;
            $(this).closest('.character-left').find('.value').text(char);
        }

        if (character === 'INIT') {
            var str = $(this).val().toUpperCase();
            $(this).val(str);
        }

        $(this).closest('.form-row.product-monogramming').find('.monogramming-textfield').each(function (index, value) {
            if ($(this).val() !== '') {
                text = text + $(this).val() + ' ' + '\n';
            }
        });

        $(this).closest('.form-row.product-monogramming').find('.monogramming-preview textarea').val(text);

        var styleClass = { 'font-family': '', 'color': '', 'text-align': '' };
        if ($('.monogram-font-class :selected').val() !== '') {
            styleClass['font-family'] = window.monogrammingFontMapping[$('.monogram-font-class :selected').val()];
        }
        if ($('.monogram-color-class :selected').val() !== '') {
            if ($('.monogram-color-class :selected').text() == 'WHITE') {
                styleClass['color'] = 'BLACK';
            } else {
                styleClass['color'] = $('.monogram-color-class :selected').text();
            }

        }
        if ($('.monogram-location-class :selected').val() !== '') {
            if ($('.monogram-location-class :selected').val() === 'ULCH') {
                styleClass['text-align'] = 'left';
            } else if ($('.monogram-location-class :selected').val() === 'URCH') {
                styleClass['text-align'] = 'right';
            } else if ($('.monogram-location-class :selected').val() === 'CCH') {
                styleClass['text-align'] = 'center';
            }
        }
        $('textarea[name$="monogramming-preview"]').css(styleClass);
    }).off('paste', '.monogramming-textfield').on('paste', '.monogramming-textfield', function (e) {
        setTimeout(function () {
            var data = $('.monogramming-textfield').val();
            var dataFull = data.replace(/[^a-zA-Z]/gi, '');
            $('.monogramming-textfield').val(dataFull);
        }, 100);
    });

    $('body').on('click', '.refresh-link', function (e) {
        e.preventDefault();
        var styleClass = { 'font-family': '', 'color': '', 'text-align': '' };
        if ($('.monogram-font-class :selected').val() !== '') {
            styleClass['font-family'] = window.monogrammingFontMapping[$('.monogram-font-class :selected').val()];
        }
        if ($('.monogram-color-class :selected').val() !== '') {
            if ($('.monogram-color-class :selected').text() == 'WHITE') {
                styleClass['color'] = 'BLACK';
            } else {
                styleClass['color'] = $('.monogram-color-class :selected').text();
            }
        }
        if ($('.monogram-location-class :selected').val() !== '') {
            if ($('.monogram-location-class :selected').val() === 'ULCH') {
                styleClass['text-align'] = 'left';
            } else if ($('.monogram-location-class :selected').val() === 'URCH') {
                styleClass['text-align'] = 'right';
            } else if ($('.monogram-location-class :selected').val() === 'CCH') {
                styleClass['text-align'] = 'center';
            }
        }
        $('textarea[name$="monogramming-preview"]').css(styleClass);
    });

    $('body').on('change', '.monogram-color-class,.monogram-font-class,.monogram-location-class', function () {
        $(this).removeClass('mono-error');
        $(this).closest('.product-monogramming').removeClass('error-msg');
    });

    if ($('textarea[name$="_giftcard_purchase_message"]').val() !== '') {
        $('input[name$="_giftcard_purchase_personalizedMessage"]').trigger('click');
    }

    
    //Initialize Keyboard arrow nav for tabs
    util.pdpTabListNavigation();
    
    // Initialize the variant-library last
    variant.init();

}

function isCatalogQuickOrderFormValid(form) {
    var isValid = true;
    var searchFields = $(form).find(".form-row.itemnumber").find('input');
    for (var i = 0; i < searchFields.length; i++) {
        if ($(searchFields[i]).val() == "") {
            isValid = false;
        } else {
            isValid = true;
            break;
        }
    };
    return isValid;
}

function formatCQONumber(value) {
    value = value.replace(/-/g, '');
    var cqoWithNoDashes = /^[0-9]{9,13}$/;
    var regX = new RegExp(cqoWithNoDashes);
    var isMatch = regX.test(value);

    if (isMatch) {
        value = reverseString(value);
        if ((value.substr(0,4) === "9999" && value.length >= 10) || value.length === 13) {
            value = value.substr(0,4) + '-' + value.substr(4,5) + '-' + value.substr(9);
        }
        else {
            value = value.substr(0,3) + '-' + value.substr(3,5) + '-' + value.substr(8);
        }

        value = reverseString(value);
    }

    return value;
}

function reverseString(value) {
    var splitArray = value.split("");
    var reverseArray = splitArray.reverse();
    var joinString = reverseArray.join("");
    return joinString;
}

function checkCQORegex(reg) {
    var regexStr = /^[0-9]{1,4}-[0-9]{5}-[0-9]{3,4}|^[0-9]{9,13}$/,
        validStatus = true,
        toStringer = reg,
        regX = new RegExp(regexStr),
        verifyStr = regX.test(toStringer);
    if (!verifyStr) {
        validStatus = false;
    }
    return {
        status: verifyStr,
        value: validStatus
    }
}

/**
 * @function initializeQuickOrderForm
 * @description Initializes the events on the quick order form (submit, cancel, delete)
 * @param {Element} form The form which will be initialized
 */

function initializeQuickOrderForm() {
    var $form = $('#dwfrm_quickorder_search');
    $form.off("blur", ".cqo-digit-and-hyphen").on("blur", ".cqo-digit-and-hyphen", function () {
        var $curObj = $(this),
            value = $curObj.val();
        if (value.length == 0) {
            $curObj.removeClass("error").closest(".form-row").removeClass("error-handle").find("span.error").not('.label-text').remove();
        }
    });
    $('body').off("paste change input keyup", ".cqo-digit-and-hyphen").on("paste change input keyup", ".cqo-digit-and-hyphen", function (e) {
        var $curObj = $(this),
            value = $curObj.val();
        if (value.length > 0) {
            $curObj.closest('.form-row').addClass('show-text');
        } else {
            $curObj.closest('.form-row').removeClass('show-text');
        }
    });
    $form.off('submit').on('submit', function (e) {
        e.preventDefault();
        var $form = $('#dwfrm_quickorder_search');
        $form.find('.generic-error').removeAttr("aria-live").hide();
        $form.find('.generic-error-required').removeAttr("aria-live").hide();
        var cqoProductFindingMethod;
        if (document.URL.indexOf("q=") != -1) {
            cqoProductFindingMethod = "CQO:Search";
        } else {
            cqoProductFindingMethod = "CQO:CQO";
        }
        if (typeof (MERCH_UTILS) !== 'undefined') {
        	MERCH_UTILS.setProductFindingMethodCookie(cqoProductFindingMethod);
        }
        if (!isCatalogQuickOrderFormValid($form)) {
            var errorMsg = '';
            $('.form-row.error-handle').find('.label-text').not('.second-label').each(function (index) {
                errorMsg = $('.form-row.error-handle').length - 1 == index && errorMsg != '' ? (errorMsg + ' and ' + $(this).text()) : (errorMsg == '' ? $(this).text() : errorMsg + ',' + $(this).text());
            });
            if ($form.find('.form-row.itemnumber input').val() !== '') {
                $form.find('.form-row.error-handle').find('.label-text').closest('label').find('span.error').hide();
                $form.find('.form-row.error-handle').find('.label-text').not('.second-label').text('Please enter a valid item # including dashes').show();
            }
            $form.find('.form-row.error-handle').find('.label-text').not('.second-label').addClass('error');
            $form.find('.generic-error-required').show().attr('aria-live','assertive');
            return false;
        } else {
            var submitCQO = false;
            var validItemNumber = $form.find('.itemnumber.show-text').find('input.cqo-digit-and-hyphen');
            validItemNumber.val(function (index, value) {
                if (value) {
                    //value = formatCQONumber(value);
                    $(this).val(value);
                    submitCQO = true;
                    return value;
                }
            });
            if (submitCQO) {
                var url = util.appendParamToURL($form.attr('action'), 'format', 'ajax');
                var applyName = $form.find('.cqo-btn-search').attr('name');
                var options = {
                    url: url,
                    data: $form.serialize() + '&' + applyName + '=x',
                    type: 'POST'
                };
                progress.show(".pdp-main");
                $.ajax(options).done(function (data) {
                    if (data.searchResultVal != null && data.searchResultVal === false) {
                        $form.find('.generic-error').show().attr('aria-live','assertive');
                        var paramsSearchVal = data.paramsSearchVal.split("|");
                        $form.find('.form-row').find('.invalid').hide();
                        var arrSearchFormValues = [];
                        for (var i = 0; i < paramsSearchVal.length; i++) {
                            var field = JSON.parse(paramsSearchVal[i]);
                            $form.find('.form-row.' + field.formId).find('input').off('input');
                            $form.find('.form-row.' + field.formId).find("span.error").remove();
                            var curFieldID = $form.find('.form-row.' + field.formId).find("input.input-text").attr("id");
                            if (!checkCQORegex(field.searchFormValue).status) {
                                var spanError = '<span id="' + curFieldID + '" class="error">' + data.errorMessage + '</span>'
                            }
                            $form.find('.form-row.' + field.formId).find("label").prepend(spanError);
                            $form.find('.form-row.' + field.formId).addClass("error-handle");
                            arrSearchFormValues.push(field.searchFormValue);
                        }
                        var eventData = {
                            event_name: "error_form",
                            error_form_response: "catalog quick order:invalid item",
                            catalog_id: arrSearchFormValues.join(",")
                        }
                        tealium.triggerEvent(eventData);
                    } else {

                        $("#main").find(".catalog-quick-order").html("").html($(data).find(".catalog-quick-order").html());
                        if ($(window).width() <= 767) {
                            var scrollValue = $('.catalog-quick-order-content .search-result').offset().top - 60;
                        } else {
                            var scrollValue = $(".catalog-quick-order-content").offset().top - 70;
                        }
                        $('html, body').animate({
                            scrollTop: scrollValue
                        }, 300);
                        initializeEvents();
                        util.updateselect();
                        imagesLoaded('.product-col-1').on('always', function () {
                            image.alternateImageSliderCQO();
                        });
                        //SM-6400 (For CQO - Pre-select Color AND/OR Size on PDP when only 1 available)
                        cqoswatches();
                        var tealimObj = $("div.get-tealim-data").data("tealim");
                        var eventData = {
                            event_name: "catalog-search",
                            catalog_id: tealimObj.catalogItemNumber,
                            search_results: tealimObj.Count,
                            product_finding_method: cqoProductFindingMethod
                        }
                        tealium.triggerEvent(eventData);

                        var searchErrors = $("div.form-row span.invalid");
                        var searchErrorsItemNotFound = $("input[name*='quickorder_search_itemnumber']", data).filter(function () { return $(this).val() != ""; });
                        if (searchErrors.length > 0 || searchErrorsItemNotFound.length > 0) {
                            $('.generic-error').show().attr('aria-live','assertive');

                            var arrSearchFormValues = [];
                            Array.from(searchErrors).forEach(function (item) {
                                arrSearchFormValues.push($(item).closest('.form-row').find('input').val());
                            });
                            Array.from(searchErrorsItemNotFound).forEach(function (item) {
                                arrSearchFormValues.push($(item).closest('.form-row').find('input').val());
                            });
                            var eventData = {
                                event_name: "error_form",
                                error_form_response: "catalog quick order:invalid item",
                                catalog_id: arrSearchFormValues.join(",")
                            };
                            tealium.triggerEvent(eventData);
                        }
                    }
                    progress.hide();
                });
                return true;
            } else {
                return false;
            }
        }
    });
    validator.init();
    $(".pdp-main").off('click', '.read-more').on('click', '.read-more', function (e) {
        e.preventDefault();
        var $parent = $(this).closest(".tab-block");
        if (!$(this).hasClass('opened')) {
            $(this).text(Resources.CLOSE).addClass('opened');
            $parent.find(".tab-content").addClass("make-height-auto");
        } else {
            $(this).text(Resources.READ_MORE).removeClass('opened');
            $parent.find(".tab-content").removeClass("make-height-auto");
        }
    });
}

var product = {
    initializeEvents: initializeEvents,
    init: function () {

        // Initialize local variables
        var thisUrl;
        var queryStringArray;
        var queryString;
        var productData;
        var baseVariationUrl;
        var variationUrl;

        // Initialize the dom
        initializeDom();

        // Decorarate the PDP with the appropriate class
        if ($('#wrapper').hasClass('pt_product-details')) {
            $('html').addClass('pdp-page');
        }

        // Initialize the page-events
        initializeEvents();

        // Create a reference to the current url
        thisUrl = window.location.href;
        thisUrl = decodeURIComponent(thisUrl); // Decoding the URL components to get split by the & parameters correctly. SM-6171

        // Does the url contain a hash?
        if (thisUrl.indexOf('#') !== -1) {

            // Build out the query-string from the url -- removing the hash
            queryStringArray = thisUrl.split('#');
            queryStringArray.shift();
            queryString = queryStringArray.join('&');

            // Retrieve the product-data from the rendered PDP
            productData = $('#pdpMain').data('productinfo');

            // Retrieve the variationUrl for the current pdp (replace the PDP action with the variation action)
            baseVariationUrl = window.location.protocol + '//' + window.location.hostname + window.Urls.productVariation;

            // Build out the variation url -- appending the productId and ajax flag to the form url
            variationUrl = util.appendParamToURL(baseVariationUrl, 'pid', productData.product_id[0]);
            variationUrl = util.ajaxUrl(variationUrl);

            // Append the original query-string to the variation url
            variationUrl = variationUrl + '&' + queryString;

            //append international params for caching
            if(typeof window.scriptLoaderData !== 'undefined' 
                && typeof window.scriptLoaderData.country !== 'undefined' 
                && typeof window.scriptLoaderData.currency !== 'undefined'){
                variationUrl = util.appendParamToURL(variationUrl, 'geCountry', window.scriptLoaderData.country); 
                variationUrl = util.appendParamToURL(variationUrl, 'geCurrency', window.scriptLoaderData.currency); 
            }
            // Remove the parameters that aren't necessary to the variation-request
            //variationUrl = util.removeParamFromURL(variationUrl, 'cgid');  // This is required for SM-6171
            variationUrl = util.removeParamFromURL(variationUrl, 'start');

            // Trigger the content-onload variant method, and launch the ajax request
            // used to initially update the PDP display
            variant.updateContentOnLoad(variationUrl);

        } else {
            //SM-6400 (Pre-select Color AND/OR Size on PDP when only 1 available)
            var varAttributes = ['color', 'size', 'width', 'waist', 'length', 'sizeFamily', 'braBandSize', 'braCupSize', 'shoeSize', 'shoeWidth'];
            $(varAttributes).each(function () {
                var curr = this.toLowerCase();
                if ($('.swatches.' + curr + ' li.selectable').length == 1) {
                    $('.swatches.' + curr + ' li.selectable:first .swatchanchor').trigger('click');
                }
            });
        }        
    }
};

module.exports = product;
